// extracted by mini-css-extract-plugin
export default {"root":"SearchMapCurrentLocationPin_root__6F47D","pinHead":"SearchMapCurrentLocationPin_pinHead__IGipR","pinPoint":"SearchMapCurrentLocationPin_pinPoint__qVM1I"};